import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms'
import { NotesTemplateService } from '../../../../api/services/notes-template.service'
import { ActivatedRoute, Router } from '@angular/router'
import { MessageService } from 'primeng/api'
import { validateAllFormFields } from '../../../../formUtils'
import { AuthService } from '../../../../api/services'
import { CareFinitySession } from '../../../services/CareFinitySession'

@Component({
  selector: 'app-add',
  templateUrl: './add-notes.component.html',
  styleUrls: [],
})
export class AddNotesComponent implements OnInit {
  categories: any[]
  readOnly = true
  isError: boolean = false
  formioComponents = {
    components: [],
  }
  note

  changedForm
    form = new UntypedFormGroup({
        notesCategoryId: new UntypedFormControl(null, []),
        description: new UntypedFormControl(null, [
            Validators.minLength(0),
            Validators.maxLength(1000),
        ]),
        templateName: new UntypedFormControl(null, [
            Validators.required,
            Validators.minLength(1),
        ]),
        templateData: new UntypedFormControl(null, [
            Validators.required,
            Validators.minLength(1),
        ]),
    });




    builderOptions:any = {
        noDefaultSubmitButton: true,

    };

  constructor(
    private router: Router,
    private notesTemplateService: NotesTemplateService,
    private activatedRoute: ActivatedRoute,
      private messageService: MessageService,
      private authService: AuthService
  ) {
    this.form
      .get('templateData')
          .setValue(JSON.stringify(this.formioComponents))

      if (!CareFinitySession.user?.roles?.globalAdminPrivilege) {

          this.builderOptions = {
              noDefaultSubmitButton: true,
              builder: {
                  advanced: {
                      title: 'Advanced',
                      weight: 10,
                      components: {
                          // From advanced
                          email: true,
                          phoneNumber: true,
                          datetime: true,
                          signature: true,
                          // From layout
                          htmlelement: true,
                          columns: true,
                          content: true,
                          table: true,
                          address: false,
                          tags: false,
                          day: false,
                          survey: false,
                          time: false,
                          currency: false,
                          url: false
                      }
                  },

                  layout: false,
                  data: false,
                  premium: false,
              }
          }
      }

      };
  

  ngOnInit() {
    this.loadCategories()
    // this.categories = [
    //    {categoryName: 'Note1', categoryId: 'id1'},
    //    {categoryName: 'Note2', categoryId: 'id2'},
    //    {categoryName: 'Note3', categoryId: 'id3'},
    //    {categoryName: 'Note4', categoryId: 'id4'},
    //    {categoryName: 'Note5', categoryId: 'id5'}
    // ];

    this.activatedRoute.paramMap.subscribe((params) => {
      const noteId = params.get('note_id')
      if (noteId === 'new') {
        this.form.get('notesCategoryId').setValue({
          categoryId: this.activatedRoute.snapshot.paramMap.get('category_id'),
          categoryName:
            this.activatedRoute.snapshot.paramMap.get('category_name'),
        })
      } else {
        this.activatedRoute.data.subscribe((notes) => {
          this.note = notes.notes_template
          this.changedForm = JSON.parse(this.note.templateData)
          // this.form.patchValue(this.note);

          this.formioComponents = JSON.parse(this.note.templateData)
          this.form.controls.notesCategoryId.setValue({
            categoryId: this.note.notesCategoryId,
            categoryName: this.note.notesCategoryName,
          })
        })
      }
    })
  }

  loadCategories() {
    this.notesTemplateService
      .notesTemplateGetAllcategories({})
      .subscribe((result) => {
        this.categories = result
      })
  }

  save() {
    validateAllFormFields(this.form)
    // console.log('user Form', this.userForm);
    if (this.form.invalid) {
      return
    }

      const { notesCategoryId, ...restOfForm } = this.form.value

      let templateData;

      if (!this.changedForm) {

          templateData = JSON.stringify(this.formioComponents);

      }
      else {
          templateData= JSON.stringify(this.changedForm)


      }

    const data = {
      ...notesCategoryId,
      ...restOfForm,
        templateData: templateData
    }

     


    this.notesTemplateService.notesTemplatePost({ body: data }).subscribe(
      (response) => {
            this.messageService.add({
                key: 'alertToast',
                severity: 'success',
                summary: 'Confirmation',
                detail: 'Note Created Successfully',
            });
            this.router.navigate(['administration', 'manage-notes'], {
                queryParams: { category_id: notesCategoryId.categoryId },
            });
      
   
      },
      (err) => {
        this.isError = true
      },
    )
    //  console.log(data);
    //console.log(JSON.stringify(this.formioComponents));
  }

  changed(event) {
    this.changedForm = event.form
  }

  navigateToNoteList(): void {
    this.router.navigate(['administration/manage-notes'])
  }
}
